<template>
  <v-tabs v-if="content[0]"
    centered
    color="cyan"
    dark
    icons-and-text
          @change="changeSlide($event)"
    v-model="visibleTab"
  >
    <v-tabs-slider color="yellow"></v-tabs-slider>
    <v-tab v-for="(tab, keyTab) in content" :key="keyTab+1" :href="'#' + tab.title + '-' +keyTab">
      {{tab.title}}
    </v-tab>

    <v-tab-item
      v-for="(tab, keyText) in content" :key="keyText+1"
      :id="tab.title + '-' +(keyText)"
    >
      <v-card flat>
        <v-img
          :src="$helper.imgServerUrl()+tab.images" :alt="tab.images.title"
        ></v-img>
        <v-card-text v-html="tab.text">
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>

  export default {
    name: "TabComponent",
    props: {
      content: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        visibleTab: ''
      }

    }, methods: {
          changeSlide(ev) {
              this.$router.push({
                  path: ev
              })
          }
      },
    mounted() {

          this.visibleTab = this.$route.params.page




    }

  }
</script>

